import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },

  {
    path: '/',
    component: Layout,
    redirect: '/muteRemoval',
    hidden: true,
    children: [
      {
        path: 'muteRemoval',
        name: 'mute-removal',
        component: () => import('@/views/muteRemoval/index'),
        meta: { title: '首页', icon: 'dashboard' }
      }
    ]
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  // {
  //   path: '/base-manage',
  //   component: Layout,
  //   name: 'BaseManage',
  //   meta: { title: '基础信息', icon: 'example', roles: ['sys_setting'] },
  //   redirect: '/base-manage/user-manage',
  //   children: [
  //     {
  //       path: 'tenant-manage',
  //       name: 'TenantManage',
  //       component: () => import('@/views/tenant/index'),
  //       meta: { title: '租户管理', icon: 'peoples', roles: ['tenant_manage'] }
  //     },
  //     {
  //       path: 'setting-perm',
  //       name: 'SettingPerm',
  //       hidden: true,
  //       component: () => import('@/views/tenant/settingPerm'),
  //       meta: { title: '权限设置', icon: 'table' }
  //     },
  //     {
  //       path: 'permission-manage',
  //       name: 'PermissionManage',
  //       component: () => import('@/views/permission/index'),
  //       meta: {
  //         title: '权限管理',
  //         icon: 'password',
  //         roles: ['permission_manage']
  //       }
  //     },
  //     {
  //       path: 'dictionary',
  //       name: 'DictManage',
  //       component: () => import('@/views/dict/index'),
  //       meta: {
  //         title: '数据字典',
  //         icon: 'documentation',
  //         roles: ['dict_manage']
  //       }
  //     },
  //     {
  //       path: 'online-user',
  //       name: 'OnlineUser',
  //       component: () => import('@/views/user/online'),
  //       meta: {
  //         title: '在线用户',
  //         icon: 'people',
  //         roles: ['onlineuser_manage']
  //       }
  //     }
  //   ]
  // },

  {
    path: '/base-manage',
    component: Layout,
    name: 'BaseManage',
    meta: { title: '声纹库', icon: 'model', roles: ['sys_setting'] },
    redirect: '/base-manage/user-manage',
    children: [
      {
        path: 'voice-entry',
        name: 'VoiceEntry',
        component: () => import('@/views/voiceEntry/index'),
        meta: { title: '声纹录入', icon: 'voiceprint' }
      },
      {
        path: 'voiceprint-management',
        name: 'VoiceprintManagement',
        component: () => import('@/views/voiceprintManagement/index'),
        meta: { title: '声纹管理', icon: 'voiceprint-man' }
      }
      // {
      //   path: '/serach',
      //   name: 'DictManage',
      //   component: () => import('@/views/serach/index'),
      //   meta: {
      //     title: '声纹搜索',
      //     icon: 'voiceprint-se',
      //     roles: ['dict_manage']
      //   }
      // },
      // {
      //   path: '/voiceprintIdentify',
      //   name: 'DictManage',
      //   component: () => import('@/views/voiceprintIdentify/index'),
      //   meta: {
      //     title: '声纹识别',
      //     icon: 'voiceprint-se',
      //     roles: ['dict_manage']
      //   }
      // },
    ]
  },
  {
    path: '/base-manage1',
    component: Layout,
    name: 'BaseManage',
    meta: { title: '声纹模型', icon: 'pretreatment', roles: ['sys_setting'] },
    redirect: '/base-manage1/user-manage',
    children: [
      {
        path: 'reduction',
        name: 'reduction',
        component: () => import('@/views/reduction/index'),
        meta: { title: '降噪', icon: 'reduction' }
      },
      {
        path: 'mute-removal',
        name: 'muteRemoval',
        component: () => import('@/views/muteRemoval/index'),
        meta: { title: '静音切除', icon: 'mute' }
      },
      {
        path: 'voiceprint-than',
        name: 'voiceprintThan',
        component: () => import('@/views/voiceprintThan/index'),
        meta: {
          title: '声纹比对',
          icon: 'voiceprint-nu'
          // roles: ['permission_manage']
        }
      },
      {
        path: 'https://116.228.202.86:10048/',
        name: 'moodIdentify',
        component: () => import('@/views/moodIdentify/index'),
        meta: {
          title: '情绪识别',
          icon: 'voiceprint-se',
          roles: ['dict_manage']
        }
      },
      {
        path: 'speaker-separation',
        name: 'speakeSeparationr',
        component: () => import('@/views/speakeSeparationr/index'),
        meta: {
          title: '讲话人分离',
          icon: 'speech'
          // roles: ['permission_manage']
        }
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
